import React, { useEffect, useState } from "react";
import { Alert, Badge, Button, Input, Spinner, Table } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { readError } from "../../helpers/whatsappTemplates";

// Accès à l'espace partenaires (réservation des displays) : personnes invitées pour ce partenaire.
// L'invitation part par email ; la connexion se fait ensuite par lien magique.
export function PartnerAccess({ partnerKey, market }) {
    const [users, setUsers] = useState(null);
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("member");
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = () => apiFetch(`${API.back}/display-partner-users?partner=${encodeURIComponent(partnerKey)}&market=${market}`, { market: false })
        .then(async (r) => { if (!r.ok) throw new Error(await readError(r)); return r.json(); })
        .then(setUsers)
        .catch((e) => { setError(e.message); setUsers([]); });
    useEffect(() => { load(); }, [partnerKey, market]); // eslint-disable-line react-hooks/exhaustive-deps

    const invite = async () => {
        setBusy(true);
        setError(null);
        const res = await apiFetch(API.back + "/display-partner-users", { method: "POST", market: false, body: JSON.stringify({ partnerKey, market, email: email.trim(), role }) });
        setBusy(false);
        if (!res.ok) { setError(await readError(res)); return; }
        setEmail("");
        load();
    };

    const remove = async (u) => {
        if (!window.confirm(`Retirer l'accès de ${u.email} ?`)) return;
        const res = await apiFetch(`${API.back}/display-partner-users?partner=${encodeURIComponent(partnerKey)}&market=${market}&email=${encodeURIComponent(u.email)}`, { method: "DELETE", market: false });
        if (!res.ok) { setError(await readError(res)); return; }
        load();
    };

    return (
        <div>
            {error && <Alert color="danger" className="py-2">{error}</Alert>}
            {users === null ? <Spinner size="sm" /> : (
                <Table size="sm" className="mb-2">
                    <tbody>
                        {users.length === 0 && <tr><td className="text-muted">Personne n'est encore invité.</td></tr>}
                        {users.map((u) => (
                            <tr key={u.email} className={u.active ? "" : "text-muted"}>
                                <td>{u.email} {u.role === "admin" && <Badge color="dark">admin</Badge>} {!u.active && <Badge color="secondary">retiré</Badge>}</td>
                                <td className="small">{u.lastLoginAt ? `connecté le ${new Date(u.lastLoginAt).toLocaleDateString("fr-FR")}` : "jamais connecté"}</td>
                                <td className="text-right">{u.active && <Button size="sm" color="link" onClick={() => remove(u)}>Retirer</Button>}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
            <div className="d-flex">
                <Input bsSize="sm" placeholder="prenom@domaine-du-partenaire.fr" value={email} onChange={(e) => setEmail(e.target.value)} className="mr-2" />
                <Input bsSize="sm" type="select" value={role} onChange={(e) => setRole(e.target.value)} style={{ width: 140 }} className="mr-2">
                    <option value="member">membre</option>
                    <option value="admin">admin (gère l'équipe)</option>
                </Input>
                <Button size="sm" color="primary" disabled={busy || !email.includes("@")} onClick={invite}>{busy ? <Spinner size="sm" /> : "Inviter"}</Button>
            </div>
        </div>
    );
}
